import React from 'react';
import ReactModal from '../../components/Modal';
import Loading from '../../components/Loading';
import { withTranslation } from 'react-i18next';

class ActivateModalDomains extends React.Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <ReactModal modalState={this.props.isOpen} className="width-sm">
                    <p>{this.props.message}</p>
                    <div className="btn-wrapper">
                        <button
                            type="button"
                            className="button button-outline button-primary width-sm btn"
                            onClick={this.props.onClose}
                            style={{ lineHeight: 'unset' }}
                        >
                            {this.props.cancleBtn ?? t('activate_domain.continue_trial')}
                        </button>

                        {this.props.isButton &&
                            (this.props.isLoadingConfirm ? (
                                <div className="loading-component">
                                    <Loading onlyPreloader padding={10} />
                                </div>
                            ) : (
                                <button
                                    type="button"
                                    className="button button-filled button-primary width-sm btn"
                                    onClick={this.props.onSubmit}
                                    style={{ lineHeight: 'unset' }}
                                >
                                    {this.props.submitBtn ??
                                        t('activate_domain.proceed_and_activate')}
                                </button>
                            ))}

                        {!this.props.isButton &&
                            (this.props.checkWithConfirm ? (
                                this.props.canConfirm &&
                                (this.props.isLoadingConfirm ? (
                                    <div className="loading-component">
                                        <Loading onlyPreloader padding={10} />
                                    </div>
                                ) : (
                                    <a
                                        onClick={this.props.onSubmit}
                                        href={this.props.activationLink}
                                        className="button button-filled button-primary width-sm btn"
                                    >
                                        {this.props.submitBtn ??
                                            t('activate_domain.proceed_and_activate')}
                                    </a>
                                ))
                            ) : (
                                <a
                                    href={this.props.activationLink}
                                    className="button button-filled button-primary width-sm btn"
                                >
                                    {this.props.submitBtn ??
                                        t('activate_domain.proceed_and_activate')}
                                </a>
                            ))}
                    </div>
                </ReactModal>
            </>
        );
    }
}

export default withTranslation()(ActivateModalDomains);
